import React from 'react';
import { YoutubeIcon, LinkedinIcon, InstagramIcon, TwitterIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-black py-12 border-t border-gray-800/50" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4" data-id="element-15">
        <div className="flex flex-col items-center" data-id="element-16">
          <h3 className="text-xl font-medium text-white mb-6" data-id="element-17">
            Follow us here
          </h3>
          <div className="flex space-x-6" data-id="element-18">
            <a href="https://www.youtube.com/@TheDealFlowShow" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-custom-green transition-colors" data-id="element-19">
              <YoutubeIcon className="w-6 h-6" data-id="element-20" />
            </a>
            <a href="https://www.linkedin.com/company/deal-flow-show" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-custom-green transition-colors" data-id="element-21">
              <LinkedinIcon className="w-6 h-6" data-id="element-22" />
            </a>
            <a href="https://x.com/thedealflowshow" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-custom-green transition-colors" data-id="element-23">
              <TwitterIcon className="w-6 h-6" data-id="element-24" />
            </a>
            <a href="https://www.instagram.com/dealflowshow/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-custom-green transition-colors" data-id="element-25">
              <InstagramIcon className="w-6 h-6" data-id="element-26" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;